import { Finding, KeyImageLabel, RadiologistStudyKeyImagesResponse } from '@/api';

export function mapKeyImages(keyImagesData: RadiologistStudyKeyImagesResponse) {
  return keyImagesData.key_images.instanceNumbers.map((instanceNumber) => ({
    id: keyImagesData.key_images.imageKeys[instanceNumber],
    image: keyImagesData.images[instanceNumber],
    instanceNumber,
    processedS3Key: keyImagesData.key_images.processed[instanceNumber],
  }));
}

export function generateKeyImageLabelList(findings: Record<string, Finding[]>): KeyImageLabel[] {
  const keyImageLabelList: KeyImageLabel[] = [];

  Object.entries(findings).forEach(([, finding]) => {
    finding.forEach((item) => {
      if (item.renderedSummary.keyImages) {
        const validKeyImages = item.renderedSummary.keyImages.filter(
          (keyImage) => !keyImageLabelList.some((existing) => existing.uuid === keyImage.uuid),
        );

        keyImageLabelList.push(...validKeyImages);
      }
    });
  });

  return keyImageLabelList;
}
